import {useTranslation} from 'react-i18next';
import EmptyCard from '../../../../../../../component/emptyCard/EmptyCard';
import {useTimetableDays} from '../../../../../../timetable/hooks/useTimetableDays';
import {STATIC_IMAGE} from '../../../../../../../config/config';

function LecturesEmpty() {
    const {t} = useTranslation('realtime');
    const {currentDateLabel} = useTimetableDays({controlled: true});

    return (
        <EmptyCard
            image={`${STATIC_IMAGE}/app/timetable/pageNoLectures.png`}
            imageAlt={t('noLectures')}
            title={t('noLectures')}
            description={t('noLecturesDescription', {day: currentDateLabel})}
            bordered={false}
        />
    );
}

export default LecturesEmpty;
